<script lang="ts" setup>
// no adding extra icon set for these socials
// just using svg in separate files
import type { SocialMediaIconRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ socialMediaLinks: SocialMediaIconRecord[] }>();
</script>

<template>
  <ul>
    <li v-for="item in socialMediaLinks" :key="item.id" class="inline pe-3 lg:pe-0 lg:ps-3">
      <NuxtLink :to="item.url" :title="item.name" target="_blank">
        <IconYouTube v-if="item.iconName === 'youtube'" class="inline" />
        <span v-if="item.iconName === 'youtube'" class="sr-only">YouTube</span>
        <IconInstagram v-if="item.iconName === 'instagram'" class="inline" />
        <span v-if="item.iconName === 'instagram'" class="sr-only">Instagram</span>
        <IconLinkedIn v-if="item.iconName === 'linkedin'" class="inline" />
        <span v-if="item.iconName === 'linkedin'" class="sr-only">LinkedIn</span>
        <IconTwitter v-if="item.iconName === 'twitter'" class="inline" />
        <span v-if="item.iconName === 'twitter'" class="sr-only">Twitter</span>
        <IconFacebook v-if="item.iconName === 'facebook'" class="inline" />
        <span v-if="item.iconName === 'facebook'" class="sr-only">Facebook</span>
      </NuxtLink>
    </li>
  </ul>
</template>

<style>

</style>
